<template>
  <div class="main-wrapper">
    <layout-header/>
    <layout-sidebar/>
    <div class="page-wrapper">
      <div class="content container-fluid">
        <!-- Header Loading Skeleton -->
        <HeaderLoadingSkeleton v-if="isLoading"/>
        <div v-else>
          <PageBreadcrumb :items="breadcrumbItems" v-if="showBreadcrumbs && breadcrumbItems.length"/>
          <div class="row">
            <div class="col-md-12" style="position: sticky; z-index: 1; top: 4rem;">
              <ProfileHeader
                v-if="showProfileHeader"
                :entity-name="entityName"
                :entity-number="entityNumber"
                :entity-address="entityAddress"
                :about-text="aboutText"
                :profile-image-url="profileImageUrl"
                :call-to-action-button-label="callToActionLabel"
                :action-button-icon="actionButtonIcon"
                :action-handler="callToActionHandler"
                :show-action-button="showActionButton"
                :show-profile-header-image-uploader="showProfileHeaderImageUploader"
                @change-profile-image-clicked="$emit('change-profile-image-clicked', $event)"
              >
                <!-- Pass the actions slot through -->
                <template v-if="$slots.headerActions" #actions>
                  <slot name="headerActions"></slot>
                </template>
              </ProfileHeader>
            </div>
            <div class="col-md-12" v-if="layout === 'horizontal' && showPageTabs && tabs && tabs.length">
              <div class="tab-pane fade show active">
                <div class="row">
                  <div class="col-lg-12">
                    <PageTabs
                      :activeTab="activeTab"
                      :tabs="tabs"
                    />
                    <div class="row">
                      <slot/> <!-- Slot for dynamic tab content -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12" v-else-if="layout === 'vertical' && showPageTabs && tabs && tabs.length">
              <div id="per_details_tab" class="tab-pane fade show active">
                <div class="row">
                  <div class="col-xl-3 col-lg-4 col-md-4 settings-tab">
                    <VerticalTabs
                      :activeTab="activeTab"
                      :tabs="tabs"
                    />
                  </div>
                  <div class="col-xl-9 col-lg-8 col-md-8">
                    <slot/> <!-- Slot for dynamic tab content -->
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12" v-else>
              <PageHeader v-if="showPageHeader" :page-title="pageTitle" :locale="locale">
                <template v-if="$slots.pageHeaderActions" #pageHeaderActions>
                  <slot name="pageHeaderActions"></slot>
                </template>
              </PageHeader>

              <slot
                name="advancedFilters"
                v-if="showAdvancedFilters"
              />

              <PageTabs
                v-if="showPageTabs && tabs && tabs.length"
                :activeTab="activeTab"
                :tabs="tabs"
              />

              <div class=""> <!-- <div class="row"> -->
                <slot/> <!-- Slot for dynamic tab content -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageTabs from "../shared/PageTabs.vue";
import PageBreadcrumb from "../shared/PageBreadcrumb.vue";
import VerticalTabs from "../shared/VerticalTabs.vue";
import PageHeader from "../shared/PageHeader.vue";
import HeaderLoadingSkeleton from "../shared/HeaderLoadingSkeleton.vue";

export default {
  name: "PageLayout",
  components: {
    PageHeader,
    VerticalTabs,
    PageTabs,
    // ProfileHeader,
    PageBreadcrumb,
    HeaderLoadingSkeleton,
  },
  data() {
    return {
      locale: this.$i18n.locale
    };
  },
  props: {
    searchContactsFilterTypes: {
      type: Array,
      default: () => []
    },
    showAdvancedFilters: {
      type: Boolean,
      default: false
    },
    breadcrumbItems: Array,
    pageTitle: {
      type: String,
    },
    layout: {
      type: String,
      default: 'vertical'
    },
    callToActionHandler: {
      type: Function,
      default: null
    },
    entityName: {
      type: String,
      default: ''
    },
    entityNumber: {
      type: String,
      default: ''
    },
    entityAddress: {
      type: String,
      default: ''
    },
    aboutText: {
      type: String,
      default: ''
    },
    profileImageUrl: {
      type: String,
      default: null
    },
    actionButtonIcon: {
      type: String,
      default: 'fa fa-edit'
    },
    showActionButton: {
      type: Boolean,
      default: false
    },
    callToActionLabel: {
      type: String,
      default: 'Action'
    },
    showProfileHeader: {
      type: Boolean,
      default: false
    },
    showBreadcrumbs: {
      type: Boolean,
      default: false
    },
    showPageTabs: {
      type: Boolean,
      default: false
    },
    showPageHeader: {
      type: Boolean,
      default: true
    },
    showProfileHeaderImageUploader: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isHeaderLoading: {
      type: Boolean,
      default: false
    },
    tabs: Array,
    activeTab: String,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/layouts/PageLayout.vue